import axios from "axios";
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      console.error(
        `Error: ${error.response.data.stack || "An error occurred"}`,
        `Status: ${status}`
      );
    }
    return Promise.reject(error);
  }
);

const validateToken = (token) => api.get(`/api/access/validate/${token}`);

const validateCode = (data) => api.post(`/api/access/validate-code`, data);

const startChat = () => api.post(`/api/puzzle/start`);

const sendChat = (data) => api.post(`/api/puzzle/send`, data);

export { validateToken, startChat, sendChat, validateCode };
